<style scoped>
.msg-row-wrapper {
  width: 100%;
  height: 100%;
}
.embed-wrapper {
  background: #000 !important;
  /*border-top: 1px solid rgb(32, 31, 31) !important;*/
  border-top: 0px solid #000 !important;
}
</style>
<template>
  <div class="page-effect embed-wrapper">
    <div v-show="embedOption === 'donation'" class="embed-inner">
      <!--<div class="embed-inner-left embed-second-inner-left">
        <h2>Text your doantion to</h2>
        <h4>646-681-5166</h4>
      </div>-->
      <div
        id="dvEmbedCode"
        class="embed-inner-right chatbot-wrapper-section"
      ></div>
    </div>
    <div v-show="embedOption === 'album'" class="embed-inner">
      <div class="embed-inner-left">
        <h2>We'd love to "see" you!</h2>
        <h4>
          Send your photo to
          <a href="mailto:pinkpic@bcrf.org" style="color: #1a1b1c"
            >pinkpic@bcrf.org</a
          >
        </h4>
      </div>
      <div class="embed-inner-right">
        <carousel
          id="owlSlider"
          :wrap="false"
          v-if="this.AlbumData.length !== 0"
          :items="5"
          :loop="false"
          :rewind="false"
          :autoplay="true"
          :autoplayTimeout="8000"
          :mouseDrag="false"
          :pullDrag="false"
          :touchDrag="false"
          :freeDrag="false"
          :margin="10"
          :dots="false"
          :startPosition="this.startIndex"
          class="sliderpnl"
          :key="componentKey"
          @changed="this.getIndex"
        >
          <div
            v-for="(slide, indx) in AlbumData"
            :key="indx"
            class="item single-pink-pic"
          >
            <img v-bind:src="slide.photoUrl" />
          </div>
          <!-- <div class="single-pink-pic">
              <img src="../../../assets/Images/video-sponsor-img-1.jpg" />
          </div>-->
          <!-- <div class="single-pink-pic">
              <img src="../../../assets/Images/video-sponsor-img-2.jpg" />
            </div>
            <div class="single-pink-pic">
              <img src="../../../assets/Images/video-sponsor-img-1.jpg" />
            </div>
            <div class="single-pink-pic">
              <img src="../../../assets/Images/video-sponsor-img-2.jpg" />
            </div>
            <div class="single-pink-pic">
              <img src="../../../assets/Images/video-sponsor-img-2.jpg" />
            </div>
            <div class="single-pink-pic">
              <img src="../../../assets/Images/video-sponsor-img-1.jpg" />
          </div>-->
        </carousel>
        <!--<slide v-for="(slide, indx) in AlbumData" :key="indx" :index="indx">
            <div class="single-pink-pic">
              <img v-bind:src="slide.photoUrl" />
            </div>
        </slide>-->
      </div>
    </div>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel2";
import jQuery from "jquery";
let $ = jQuery;
import db from "@/components/firebaseInit";
//import props from '@/VueCtkDateTimePicker/props';
//import analytics from "@/components/Analytics";

let vm;
let owlObject;
//let embedSwitchTimer;
export default {
  components: {
    carousel,
  },
  props: [
    //"sessionid"
    "showPlayerHeader",
  ],
  data() {
    return {
      embededPlayer: this,
      enableEmbed: false,
      showEmbed: false,
      embedOption: "",
      sessionId: "",
      instanceId: "",
      AlbumData: [],
      loaded: false,
      componentKey: 0,
      startIndex: 0,
      currentIndex: 0,
    };
  },
  watch: {
    showPlayerHeader() {
      if (vm.enableEmbed) {
        vm.startEmbed();
        //vm.tryAutoSwitchEmbed();
      } else {
        vm.stopEmbed();
        $("#dvEmbedCode").empty();
      }
    },
  },
  created() {
    vm = this;
  },
  beforeDestroy() {
    vm.swithEmbed("");
    vm.toggleEmbed(false);
  },
  mounted() {
    //move to firestore listener when complete otherwise pass 'false'
    //vm.toggleEmbed(this.enableEmbed);
    //vm.fetchScript();
    //$('#dvAlbum').animate({height:10},200);
    //window.resizeTo(250, 250);
    //console.log("InstanceID : "+ vm.getInstanceId);
    //$('.sliderpnl').trigger('refresh.owl.carousel');
  },
  methods: {
    getIndex() {
      vm.currentIndex = $("div.active").index() + 5;
    },
    initEmbed(sessionId, instanceId) {
      debugger;
      //alert();
      vm.sessionId = sessionId;
      vm.instanceId = instanceId;
      //$("#dvEmbedCode").attr("id", "dvEmbedCode" + vm.instanceId);
      //$(".sliderpnl").attr("id", "crousel" + vm.instanceId);
      //$('#sliderpnl').attr('id', "sliderpnl"+vm.instanceId);
      //console.log("InstanceID : "+  vm.instanceId);
      $("#dvEmbedCode").empty();
      //$("#dvEmbedCode" + vm.instanceId).empty();
      vm.bottombarStatus();
    },

    toggleEmbed(isEnabled) {
      //alert(isEnabled);
      vm.enableEmbed = isEnabled;
      if (vm.enableEmbed) {
        vm.startEmbed();
        //vm.tryAutoSwitchEmbed();
      } else {
        vm.stopEmbed();
        $("#dvEmbedCode").empty();
      }
    },

    startEmbed() {
      //alert(vm.enableEmbed);
      if (vm.instanceId === "embedLiveStream") {
        $("#divLiveVideoContainer").insertAfter("#divLiveStreamContainer");
        if (vm.enableEmbed) {
          $("#divLiveStreamContainer").addClass("video-player-with-embed");
          $("#embedLiveStream").show();
        } else {
          $("#divLiveStreamContainer").removeClass("video-player-with-embed");
          $("#embedLiveStream").hide();
        }
      }
      if (vm.instanceId === "embedLiveVideo") {
        $("#divLiveStreamContainer").insertAfter("#divLiveVideoContainer");
        if (vm.enableEmbed) {
          $("#divLiveVideoContainer").addClass("video-player-with-embed");
          $("#embedLiveVideo").show();
        } else {
          $("#divLiveVideoContainer").removeClass("video-player-with-embed");
          $("#embedLiveVideo").hide();
        }
      }
    },

    stopEmbed() {
      if (vm.instanceId === "embedLiveStream") {
        $("#divLiveStreamContainer").removeClass("video-player-with-embed");
        $("#embedLiveStream").hide();
      }
      if (vm.instanceId === "embedLiveVideo") {
        $("#divLiveVideoContainer").removeClass("video-player-with-embed");
        $("#embedLiveVideo").hide();
      }
    },

    //Manual Switch
    swithEmbed(option) {
      vm.embedOption = option;
    },

    //AutoSwitch
    //toggleEmbed() {
    //  if (vm.embedOption == "donation") {
    //    vm.embedOption = "album";
    //  } else {
    //    vm.embedOption = "donation";
    //  }
    //},

    //tryAutoSwitchEmbed() {
    //  if (embedSwitchTimer) {
    //    clearInterval(embedSwitchTimer);
    //  }
    //  embedSwitchTimer = setInterval(function () {
    //    vm.toggleEmbed();
    //  }, 5000);
    //},

    bottombarStatus: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      db.collection(obj.eventcollectionname)
        .doc("SessionList")
        .collection("Sessions")
        .doc(vm.sessionId)
        .get()
        .then(function (doc) {
          debugger;
          if (doc.exists) {
            vm.fetchScript();
            vm.enableEmbed = doc.data().SessionTypeDetails.EnableBottomBar;
            if (vm.enableEmbed === true) {
              vm.embedOption = "donation";
              vm.toggleEmbed(true);
            } else {
              $("#dvEmbedCode").empty();
              $("#dvEmbedCode" + vm.instanceId).empty();
              vm.swithEmbed("");
              vm.toggleEmbed(false);
            }
          }
        });
    },
    search(nameKey, myArray) {
      for (var i = 0; i < myArray.length; i++) {
        if (myArray[i].id === nameKey) {
          return i;
        }
      }
    },

    fetchScript() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      db.collection(obj.eventcollectionname)
        .doc("SessionList")
        .collection("Sessions")
        .doc(vm.sessionId)

        ////console.log("Session id selected :"+vm.sessionid);
        //db.collection("OA_UAT_C1598002519080E1598006401190")
        //  .doc("SessionList")
        //  .collection("Sessions")
        //  .doc("1488000")
        .onSnapshot(function (doc) {
          var embededActive = doc.data().SessionTypeDetails.Active;
          var EmbedCode = doc.data().SessionTypeDetails.EmbedCode;
          var EnableBottomBar = doc.data().SessionTypeDetails.EnableBottomBar;
          var photoDirectory = "";
          debugger;
          if (doc.data().SessionTypeDetails.PhotoWallAlbum) {
            photoDirectory =
              doc.data().SessionTypeDetails.PhotoWallAlbum.photoDirectory;
          }
          //alert("EnableBottomBar: " + EnableBottomBar);
          if (EnableBottomBar === true) {
            console.log("embededActive -" + embededActive);
            if (embededActive === "EmbedCode") {
              $("#dvEmbedCode").empty();
              //$("#dvEmbedCode" + vm.instanceId).empty();
              vm.swithEmbed("donation");
              vm.toggleEmbed(true);
              if (EmbedCode.indexOf("<iframe") > -1) {
                // document.getElementById(
                //   "dvEmbedCode" + vm.instanceId
                // ).innerHTML = EmbedCode;

                $("#dvEmbedCode").empty();
                //document.getElementById("dvEmbedCode").innerHTML = EmbedCode;
                $("#dvEmbedCode").html(EmbedCode);
              } else {
                $("#dvEmbedCode").empty();
                //$('body').find('script[id="embedscript"])').remove();
                if (document.scripts.namedItem("embedscript") !== null) {
                  document.scripts.namedItem("embedscript").remove();
                }

                let externalScript = document.createElement("script");
                externalScript.setAttribute("id", "embedscript");
                //  EmbedCode= EmbedCode.replace(
                //   "element=dvEmbedCode",
                //   "element=dvEmbedCode" + vm.instanceId
                // );
                externalScript.setAttribute("src", EmbedCode);
                document.body.append(externalScript);
              }
            } else if (embededActive === "PhotoWallAlbum") {
              vm.swithEmbed("album");
              vm.toggleEmbed(true);
              //$("#dvEmbedCode" + vm.instanceId).empty();
              $("#dvEmbedCode").empty();
              vm.AlbumData = [];
              vm.startIndex = 0;
              vm.currentIndex = 0;
              if (photoDirectory !== "") {
                db.collection(obj.eventcollectionname)
                  .doc("PhotoWall")
                  .collection(photoDirectory)
                  .where("photoDirectory", "==", photoDirectory)
                  .onSnapshot(function (snapshot) {
                    //var temp=[];
                    debugger;
                    snapshot.docChanges().forEach((docChange) => {
                      switch (docChange.type) {
                        case "added":
                          if (docChange.doc.data().IsPublished === true) {
                            vm.AlbumData.push({
                              id: docChange.doc.id,
                              photoUrl: docChange.doc.data().photoUrl,
                              LastModifiedDate:
                                docChange.doc.data().LastModifiedDate,
                              IsPublished: docChange.doc.data().IsPublished,
                            });
                          }
                          //vm.currentIndex = vm.AlbumData.length - 1;
                          vm.startIndex = 0;
                          break;
                        case "modified":
                          var ind = vm.search(docChange.doc.id, vm.AlbumData);
                          if (docChange.doc.data().IsPublished === false) {
                            if (ind !== undefined) {
                              vm.AlbumData.splice(ind, 1);
                              vm.currentIndex = vm.currentIndex - 1;
                            }
                          } else {
                            if (ind === undefined) {
                              vm.AlbumData.push({
                                id: docChange.doc.id,
                                photoUrl: docChange.doc.data().photoUrl,
                                LastModifiedDate:
                                  docChange.doc.data().LastModifiedDate,
                                IsPublished: docChange.doc.data().IsPublished,
                              });
                            }
                          }

                          break;
                      }
                    });
                    vm.AlbumData = vm.AlbumData.sort(function compare(a, b) {
                      var dateA = new Date(a.LastModifiedDate.seconds);
                      var dateB = new Date(b.LastModifiedDate.seconds);
                      return dateA - dateB;
                    });

                    vm.startIndex = vm.currentIndex;
                    if (owlObject == undefined) {
                      vm.componentKey += 1;
                      $("#owlSlider").trigger("refresh.owl.carousel");
                    } else {
                      vm.componentKey += 1;
                    }
                  });
              } else {
                vm.toggleEmbed(false);
              }
            } else {
              vm.toggleEmbed(false);
            }
          } else {
            vm.toggleEmbed(false);
          }
        });
    },
  },
};
</script>

<style>
@font-face {
  font-family: "Conv_Hurme Design - HurmeGeometricSans4 SemiBold";
  src: url("../../../assets/fonts/hurme_1/Hurme Design - HurmeGeometricSans4 SemiBold.eot");
  src: local("☺"),
    url("../../../assets/fonts/hurme_1/Hurme Design - HurmeGeometricSans4 SemiBold.woff")
      format("woff"),
    url("../../../assets/fonts/hurme_1/Hurme Design - HurmeGeometricSans4 SemiBold.ttf")
      format("truetype"),
    url("../../../assets/fonts/hurme_1/Hurme Design - HurmeGeometricSans4 SemiBold.svg")
      format("svg");
  font-weight: normal;
  font-style: normal;
}
/* ------------------------ Playerbottom-panel-------------------------*/
body .player-full-screen .vjs-custom-skin {
  height: 100% !important;
}
body
  .player-full-screen
  #divLiveStreamContainer.video-player-with-embed
  .video-js,
body
  .player-full-screen
  #divLiveVideoContainer.video-player-with-embed
  .video-js {
  height: 100% !important;
}
body .video-player-with-embed .embed-wrapper {
  height: 25vh;
}
body .single-pink-pic {
  height: calc(25vh - 30px);
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background: #000; */
}
.video-player-with-embed {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
body #LiveStage .player-wrapper-hld .vjs-custom-skin {
  height: 100% !important;
}
.vjs-custom-skin .video-js {
  height: 100% !important;
}
/*.player-full-screen #divLiveVideoContainer.video-player-with-embed .video-js,
.player-full-screen #divLiveStreamContainer.video-player-with-embed .video-js {
  width: 100% !important;
  height: calc(80vh - 47px) !important;
}
#divLiveVideoContainer.video-player-with-embed .video-js,
#divLiveStreamContainer.video-player-with-embed .video-js {
  width: 100% !important;
  height: calc(65vh - 47px) !important;
}
.player-full-screen #divLiveVideoContainer .video-js, .player-full-screen #divLiveStreamContainer .video-js {
    width: 100% !important;
    height: calc(100vh - 47px) !important;
}
#divLiveVideoContainer .video-js,
#divLiveStreamContainer .video-js {
  width: 100% !important;
  height: calc(100vh - 179px) !important;
}*/
.embed-wrapper {
  /*height: calc(35vh - 133px);*/
  background: #d2006f;
}
.embed-inner-left {
  padding: 25px;
  border-right: 1px solid #fff;
  height: 100%;
  position: relative;
  flex: 0 0 20%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 312px;
}
.embed-inner-left h2 {
  font-size: 28px !important;
  font-weight: 600;
  color: #ffffff;
  font-family: "Conv_Hurme Design - HurmeGeometricSans4 SemiBold";
}
.embed-inner-left h4 {
  font-size: 24px !important;
  font-weight: 400;
  color: #1a1b1c;
  margin-top: 16px;
  font-family: "Conv_Hurme Design - HurmeGeometricSans4 SemiBold";
  margin-bottom: 0;
}
.embed-inner {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
}
.embed-inner-right {
  width: 100%;
  /* display: flex; */
  justify-content: flex-start;
  align-items: center;
  padding: 15px;
  height: 100%;
  overflow: hidden;
}
.embed-inner-right.chatbot-wrapper-section {
  padding: 0 !important;
}
.hooper-list {
  padding-top: 20px;
}
/* .single-pink-pic {
  height: 150px;
  width: 16.2%;
  background: #000;
  display: inline-block;
  margin-right: 10px;
} */
.video-player-with-embed .embed-wrapper {
  display: block !important;
}
.embed-inner-left.embed-second-inner-left h4 {
  font-size: 46px !important;
}
/*.video-js .vjs-control-bar {
  background: #000;
}*/
.sliderpnl {
  display: flex;
}
.embed-inner-right .owl-carousel .owl-item img {
  width: auto;
}
.left-block.txt,
.right-block.msg-block {
  background-color: transparent !important;
}
.left-block.txt span {
  font-size: 2rem !important;
  color: #000 !important;
  font-weight: 500 !important;
}
/*.single-pink-pic {
  width: 293px;
  height: 165px;
  background: #000;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}*/
.single-pink-pic img {
  width: 100% !important;
}
.msg-row-wrapper {
  height: 100% !important;
  width: 100%;
}
.left-block.txt {
  flex: 0 0 262px !important;
  max-width: 262px !important;
}
.scroll-wrapper {
  justify-content: center !important;
  height: 100% !important;
}
/* .msg-block-wrapper {
    width: 100% !important;
    display: flex !important;
    justify-content: flex-start !important;
    align-items: center !important;
} */
@media only screen and (min-width: 2000px) and (max-width: 2560px) {
  /*.player-full-screen #divLiveVideoContainer.video-player-with-embed .video-js,
  .player-full-screen
    #divLiveStreamContainer.video-player-with-embed
    .video-js {
    width: 100% !important;
    height: calc(83.5vh - 47px) !important;
  }
  #divLiveVideoContainer.video-player-with-embed .video-js,
  #divLiveStreamContainer.video-player-with-embed .video-js {
    width: 100% !important;
    height: calc(73vh - 47px) !important;
  }

  .player-full-screen #divLiveVideoContainer .video-js,
  .player-full-screen #divLiveStreamContainer .video-js {
    width: 100% !important;
    height: calc(100vh - 75px) !important;
  }*/
  .embed-inner-left h2 {
    font-size: 42px !important;
  }
  .embed-inner-left h4 {
    font-size: 35px !important;
  }
  /*.single-pink-pic {
    height: 223px;
  }*/
  .embed-second-inner-left h2 {
    font-weight: 300 !important;
    font-size: 48px !important;
    color: #1b1c1a !important;
  }
  .embed-inner-left.embed-second-inner-left h4 {
    font-size: 68px !important;
    color: #fff;
  }
  /*.video-js .vjs-control-bar {
    background: #000;
  }*/
  /*.single-pink-pic {
    width: 396px;
    height: 223px;
  }*/
  .embed-inner-right {
    display: flex !important;
    justify-content: flex-start;
    align-items: center;
  }
  /*.embed-wrapper {
    height: calc(25vh - 133px);
  }*/
}
@media only screen and (min-width: 1441px) and (max-width: 1600px) {
  /*.player-full-screen #divLiveStreamContainer.video-player-with-embed .video-js, .player-full-screen #divLiveVideoContainer.video-player-with-embed .video-js {
  width: 100%!important;
  height: calc(78vh - 45px)!important;
}
#divLiveVideoContainer.video-player-with-embed .video-js, #divLiveStreamContainer.video-player-with-embed .video-js {
    width: 100% !important;
    height: calc(65vh - 81px) !important;
}
.embed-wrapper {
height: calc(35vh - 99px);}
.embed-inner-right {
width: 100%;
padding: 15px;
}*/
  .embed-inner-left h2 {
    font-size: 22px !important;
  }
  .embed-inner-left h4 {
    font-size: 20px !important;
    margin-top: 10px;
  }
}
@media only screen and (min-width: 1367px) and (max-width: 1440px) {
  /*.embed-wrapper {
    height: calc(32vh - 110px);
  }
  .player-full-screen #divLiveVideoContainer.video-player-with-embed .video-js,
  .player-full-screen
    #divLiveStreamContainer.video-player-with-embed
    .video-js {
    width: 100% !important;
    height: calc(105vh - 226px) !important;
  }
  #divLiveVideoContainer.video-player-with-embed .video-js,
  #divLiveStreamContainer.video-player-with-embed .video-js {
    width: 100% !important;
    height: calc(70vh - 65px) !important;
  }
  #divLiveVideoContainer .video-js,
  #divLiveStreamContainer .video-js {
    width: 100% !important;
    height: calc(100vh - 165px) !important;
  }*/
  .embed-inner-left h2 {
    font-size: 21px !important;
  }
  .embed-inner-left h4 {
    font-size: 19px !important;
    margin-top: 10px;
  }
  .embed-second-inner-left h2 {
    font-size: 24px !important;
  }
  .embed-inner-left.embed-second-inner-left h4 {
    font-size: 38px !important;
  }
  /*.single-pink-pic {
    width: 217px;
    height: 122px;
  }*/
}
@media only screen and (max-width: 1366px) {
  /*.embed-wrapper {
    height: calc(38vh - 97px);
  }
  .player-full-screen #divLiveVideoContainer.video-player-with-embed .video-js,
  .player-full-screen
    #divLiveStreamContainer.video-player-with-embed
    .video-js {
    width: 100% !important;
    height: calc(78vh - 47px) !important;
  }
  #divLiveVideoContainer.video-player-with-embed .video-js,
  #divLiveStreamContainer.video-player-with-embed .video-js {
    width: 100% !important;
    height: calc(60vh - 47px) !important;
  }
  #divLiveVideoContainer .video-js,
  #divLiveStreamContainer .video-js {
    width: 100% !important;
    height: calc(100vh - 156px) !important;
  }*/
  .embed-inner-left h2 {
    font-size: 20px !important;
  }
  .embed-inner-left h4 {
    font-size: 18px !important;
  }
  .embed-second-inner-left h2 {
    font-size: 23px !important;
  }
  .embed-inner-left.embed-second-inner-left h4 {
    font-size: 35px !important;
  }
  /*.single-pink-pic {
    width: 205px;
    height: 115px;
  }*/
}
@media only screen and (max-width: 1024px) {
  /*.embed-wrapper {
    height: calc(26vh - 97px);
  }
  .player-full-screen #divLiveVideoContainer.video-player-with-embed .video-js,
  .player-full-screen
    #divLiveStreamContainer.video-player-with-embed
    .video-js {
    width: 100% !important;
    height: calc(87vh - 47px) !important;
  }
  #divLiveVideoContainer.video-player-with-embed .video-js,
  #divLiveStreamContainer.video-player-with-embed .video-js {
    width: 100% !important;
    height: calc(72vh - 47px) !important;
  }
  #divLiveVideoContainer .video-js,
  #divLiveStreamContainer .video-js {
    width: 100% !important;
    height: calc(100vh - 155px) !important;
  }*/
  .embed-inner-left {
    padding: 10px;
  }
  .embed-inner-left h4 {
    font-size: 21px !important;
    font-weight: 400;
    color: #1a1b1c;
  }
  .embed-inner-left h2 {
    font-size: 24px !important;
  }
  /* .single-pink-pic {
    width: 145px;
    height: 82px;
  }*/
}
</style>